import { RouteObject } from "react-router-dom";

export const ticketValidationRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Ticket Validation" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          // Redirect to /ticket-validation/returns for backward compatibility
          const { Navigate } = await import("react-router-dom");
          return {
            element: <Navigate replace to="/ticket-validation/returns" />,
          };
        },
      },
      {
        path: "returns",
        handle: { breadcrumb: "Returns" },
        async lazy() {
          const { TicketValidationPage } =
            await import("./ticket-validation-page");
          return { Component: TicketValidationPage };
        },
      },
      {
        path: "oms",
        handle: { breadcrumb: "OMS" },
        async lazy() {
          const { OmsValidationPage } = await import("./oms-validation-page");
          return { Component: OmsValidationPage };
        },
      },
      {
        path: "marketing",
        handle: { breadcrumb: "Marketing" },
        async lazy() {
          const { MarketingValidationPage } =
            await import("./marketing-validation-page");
          return { Component: MarketingValidationPage };
        },
      },
    ],
  },
];
